import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/gestionTiempos/registrations";
import registrations from "../../models/gestionTiempos/registrations";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    service: new service(),
    date: null,
    registrations: [],
    concepts: [],
    csCosts: [],
    audit: [],
    newRegis: {},
    deleteItem: {},
    editItems: [],
    dialogShow: false,
    newRule: {},
    rules: [],
    dateTo: "12:00",
    dateFrom: "06:00",
    currentAccount: [],
  },
  mutations: {
    setDate(state, date) {
      state.date = date;
    },
    setRegistrations(state, data) {
      state.registrations = data;
    },
    setConcepts(state, data) {
      state.concepts = data;
    },
    setConceptsNov(state, data) {
      state.conceptsNov = data;
    },
    setCsCosts(state, data) {
      state.csCosts = data;
    },
    setCsCostsNov(state, data) {
      state.csCostNov = data;
    },
    setAudit(state, data) {
      state.audit = data;
    },
    setNewRegis(state, data) {
      state.newRegis = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setEdit(state, options) {
      state.editItems = options;
    },
    setDialogShow(state, data) {
      state.dialogShow = data;
    },
    setNewRule(state, data) {
      state.newRule = data;
    },
    setRules(state, data) {
      state.rules = data;
    },
    setDateTo(state, data) {
      state.dateTo = data;
    },
    setDateFrom(state, data) {
      state.dateFrom = data;
    },
    setCurrentAccount(state, data) {
      state.currentAccount = data;
    },
  },
  actions: {
    async getCurrentAccount(state, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getCurrentAccount(data);
          state.commit("setCurrentAccount", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getRegistrations(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getRegistrations(
            state.state.date
          );

          state.commit("setRegistrations", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getConcepts(state) {
      try {
        let item = await state.state.service.getConceptsNov();
        state.commit("setConcepts", item);
      } catch (error) {
        console.log(error);
      }
    },
    async getCsCost(state) {
      try {
        let item = await state.state.service.getCsCostNov();

        state.commit("setCsCosts", item);
      } catch (error) {
        console.log(error);
      }
    },
    async getCsCostGuidelines(state) {
      try {
        let item = await state.state.service.getCsCostGuidelines();

        state.commit("setCsCosts", item);
      } catch (error) {
        console.log(error);
      }
    },
    async getAudit(state) {
      try {
        let item = await state.state.service.getAudit();

        state.commit("setAudit", item);
      } catch (error) {
        console.log(error);
      }
    },
    async getNewRegis(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.newRegis).then(() => {
            let options = state.state.registrations;

            state.commit("setRegistrations", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteRegis(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.registrations;
            options = options.filter((option) => {
              return option.originEntry !== state.state.deleteItem.entrada;
            });

            state.commit("setRegistrations", options);
            resolve(true);
          });
        } catch (error) {
          reject(error.response.data);
        }
      });
    },
    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.editItems).then(() => {
            let item = state.state.editItems;
            let id =
              state.state.editItems.empId.toString() +
              state.state.editItems.fechaEntrada;

            let options = state.state.registrations;
            options = options.map((option) => {
              if (option.originEntry != state.state.editItems.entradaOriginal) {
                return option;
              }

              item = registrations.fromJson({
                id: id,
                EmpId: item.empId,
                Entrada: item.fechaEntrada,
                Salida: item.fechaSalida,
                ConceptoId: item.conceptoId,
                CsCostoId: item.csCostoId,
                Observaciones: item.observaciones,
                comentId: item.comentId,
                NomConcepto: item.nombreConcepto,
                NomCsCosto: item.nombreCsCosto,
                EntradaOriginal: item.entradaOriginal,
                SalidaOriginal: item.salidaOriginal,
                EntModif: item.entModif,
              });
              return item;
            });

            state.commit("setRegistrations", options);
            resolve(true);
          });
        } catch (error) {
          console.log(error);
          reject(error);
        }
      });
    },
    async newRule(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .newRule(state.state.newRule)
            .then((data) => {
              let items = state.state.newRule;
              state.commit("setNewRule", items);

              resolve(data);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    getInfoRules(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getInfoRules();

          state.commit("setRules", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
